import React from 'react';
import { motion } from 'framer-motion';
import { 
  Card, 
  CardBody, 
  CardHeader,
  Chip,
  Divider
} from "@heroui/react";

const UnifiedContactCard = () => {
  const contactItems = [
    {
      type: 'phone',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
          <path fillRule="evenodd" d="M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z" clipRule="evenodd" />
        </svg>
      ),
      title: "Telefon kontaktowy",
      items: [
        { text: "+48 690 481 963", link: "tel:+48690481963" }
      ],
      color: "text-blue-500"
    },
    {
      type: 'email',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
          <path d="M1.5 8.67v8.58a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V8.67l-8.928 5.493a3 3 0 0 1-3.144 0L1.5 8.67Z" />
          <path d="M22.5 6.908V6.75a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3v.158l9.714 5.978a1.5 1.5 0 0 0 1.572 0L22.5 6.908Z" />
        </svg>
      ),
      title: "Email",
      items: [
        { text: "kontakt@itfe.pro", link: "mailto:kontakt@itfe.pro" }
      ],
      color: "text-purple-500"
    }
    //{
    //  type: 'address',
    //  icon: (
    //    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
    //      <path fillRule="evenodd" d="m11.54 22.351.07.04.028.016a.76.76 0 0 0 .723 0l.028-.015.071-.041a16.975 16.975 0 0 0 1.144-.742 19.58 19.58 0 0 0 2.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 0 0-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 0 0 2.682 2.282 16.975 16.975 0 0 0 1.145.742ZM12 13.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" clipRule="evenodd" />
    //    </svg>
    //  ),
    //  title: "Adres",
    //  items: [
    //    { text: "ul. Przykładowa 123", link: null, badge: null },
    //    { text: "00-001 Warszawa", link: "https://maps.google.com/?q=00-001+Warszawa,+Przykładowa+123", badge: null, isMapLink: true }
    //  ],
    //  color: "text-green-500"
    //},
    //{
    //  type: 'hours',
    //  icon: (
    //    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
    //      <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 6a.75.75 0 0 0-1.5 0v6c0 .414.336.75.75.75h4.5a.75.75 0 0 0 0-1.5h-3.75V6Z" clipRule="evenodd" />
    //    </svg>
    //  ),
    //  title: "Godziny pracy",
    //  items: [
    //    { text: "Poniedziałek - Piątek: 9:00 - 17:00", link: null, badge: null }
    //  ],
    //  color: "text-amber-500"
    //}
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Card className="shadow-lg border border-default-200 overflow-hidden">
        <CardHeader className="bg-gradient-to-r from-primary/5 to-secondary/5 flex items-center gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-primary">
            <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM6.262 6.072a8.25 8.25 0 1 0 10.562-.766 4.5 4.5 0 0 1-1.318 1.357L14.25 7.5l.165.33a.809.809 0 0 1-1.086 1.085l-.604-.302a1.125 1.125 0 0 0-1.298.21l-.132.131c-.439.44-.439 1.152 0 1.591l.296.296c.256.257.622.374.98.314l1.17-.195c.323-.054.654.036.905.245l1.33 1.108c.32.267.46.694.358 1.1a8.7 8.7 0 0 1-2.288 4.04l-.723.724a1.125 1.125 0 0 1-1.298.21l-.153-.076a1.125 1.125 0 0 1-.622-1.006v-1.089c0-.298-.119-.585-.33-.796l-1.347-1.347a1.125 1.125 0 0 1-.21-1.298L9.75 12l-1.64-1.64a6 6 0 0 1-1.676-3.257l-.172-1.03Z" clipRule="evenodd" />
          </svg>
          <h3 className="text-xl font-semibold">Dane kontaktowe</h3>
        </CardHeader>
        <CardBody>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {contactItems.map((item, index) => (
              <div key={index} className="flex gap-4">
                <div className={`p-2 rounded-lg h-min ${item.type === 'phone' ? 'bg-blue-50 dark:bg-blue-900/20' : 
                               item.type === 'email' ? 'bg-purple-50 dark:bg-purple-900/20' :
                               item.type === 'address' ? 'bg-green-50 dark:bg-green-900/20' : 
                               'bg-amber-50 dark:bg-amber-900/20'}`}>
                  <div className={item.color}>{item.icon}</div>
                </div>
                <div>
                  <h4 className="font-medium mb-2">{item.title}</h4>
                  <div className="space-y-2">
                    {item.items.map((detail, idx) => (
                      <div key={idx} className="flex items-center flex-wrap gap-2">
                        {detail.link ? (
                          <a 
                            href={detail.link} 
                            className={`hover:underline ${item.color} font-medium`}
                            target={detail.isMapLink ? "_blank" : undefined}
                            rel={detail.isMapLink ? "noopener noreferrer" : undefined}
                          >
                            {detail.text}
                          </a>
                        ) : (
                          <span className="text-gray-700 dark:text-gray-300">{detail.text}</span>
                        )}
                        
                        {detail.badge && (
                          <Chip size="sm" variant="flat" className="text-xs">
                            {detail.badge}
                          </Chip>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          <Divider className="my-6" />
          
          <div className="flex justify-between items-center">
            <span className="text-sm text-gray-500 dark:text-gray-400">
              Skontaktuj się z nami, aby omówić potrzeby IT Twojej firmy
            </span>
            <Chip color="primary" variant="flat" className="animate-pulse">
              Odpowiadamy szybko
            </Chip>
          </div>
        </CardBody>
      </Card>
    </motion.div>
  );
};

export default UnifiedContactCard;
